import { i18n } from '@/lang'

export default () => {
  return {
    audio_first_question_for_icons: i18n.t('message.audio_first_question_for_icons'),
    audio_icons_select_wrong: i18n.t('message.audio_icons_select_wrong'),
    audio_icons_select_correct: i18n.t('message.audio_icons_select_correct'),
    audio_first_question_for_cards: i18n.t('message.audio_first_question_for_cards'),
    audio_first_question_for_calc: i18n.t('message.audio_first_question_for_calc'),
    audio_good_job: i18n.t('message.audio_good_job'),
    audio_unlocked_badge: i18n.t('message.audio_unlocked_badge'),
    audio_calc_question_1: i18n.t('message.audio_calc_question_1'),
    audio_calc_question_2: i18n.t('message.audio_calc_question_2'),
    audio_calc_question_3_4: i18n.t('message.audio_calc_question_3_4'),
  }
}



// WEBPACK FOOTER //
// ./src/data/config/audio.js